import React, { useState, useRef } from 'react'
import { message } from 'antd'
import classNames from 'classnames'
import { addToIdeaMass } from '../addInspirationModal/common'
import Icon from '../icon'
import AssociateTaskModal from '../associateTaskModal'
import { getProjectSource } from '../../common/trackCommon'
import request from '../../utils/request'
import util from '../../utils/util'
import * as auth from '../../utils/auth'
import onCollectNotification from './notification'
import { renderMoveImage } from '../useFunModal/moveImage'
import { PLATFORM_VALUE } from '../platformConfig'
import messageSuccess from './messageSuccess'
import userInfo from '../../common/userInfo'
import Collect from './index'
import './index.less'

/**
 *
 * @onCollect 采集按钮点击事件
 * @currentBlog 当前所有需要的数据 其中 采集按钮会返回 currentBlog.item
 */

const fetchIdeaMass = async () => {
  try {
    const res = await request.sget('/zhikuan/ins/inspiration/get-quick-inspiration', { queryType: 3, rankStatus: -2 }, 'getIdeaMass')
    return res
  } catch (error) {
    return error
  }
}

const TempFastCollect = (props) => {
  const { currentBlog, afterJoin, children, className, beforeCollect, isCollectReport, onCollect, hasCurInstated } = props
  const { imageGroupEntityId, itemId, productId, title, isRecorded, goodsType, platformId, mnPlatformType } = currentBlog || {}
  const blogId = imageGroupEntityId || productId || itemId
  const [loading, setLoading] = useState(false)
  const [taskConfirmVisible, setTaskConfirmVisible] = useState(false)
  const taskConfirmTemp = useRef(null)
  const updateInspirationId = useRef(null)

  const _onCollect = async () => {
    const ideaMass = await fetchIdeaMass()

    if (!ideaMass?.id) {
      return message.warning(ideaMass?.errorDesc)
    }

    const flag = await beforeCollect?.()
    if (flag === false) { return }
    // 没有 isRecord 字段也可以采集,所以这里用 === false
    if (isRecorded === false) {
      message.error('该商品暂时不支持采集')
      return
    }
    if (loading) { return }
    setLoading(true)
    try {
      const params = {
        inspirationId: ideaMass.id,
        blogList: [
          {
            colorId: currentBlog?.colorId,
            inspirationId: hasCurInstated ? currentBlog?.inspirationId : null,
            blogId,
            platformId: platformId || mnPlatformType || (goodsType === 100 ? PLATFORM_VALUE.DY : PLATFORM_VALUE.ITEM)
          }]
      }
      const res = await addToIdeaMass(params, { ignoreError: true })
      if (res?.effectTargetNum && auth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21'])) {
        taskConfirmTemp.current = res
        setTaskConfirmVisible(true)
      }
      updateInspirationId.current = res.id
      messageSuccess({
        collectIdList: res.collectIdList,
        loginUserInfo: res.loginUserInfo,
        name: res.name,
        data: res,
        isFast: true,
        callback: async () => {
          renderMoveImage({
            blogId: res.blogIdList?.[0] || blogId,
            blog: currentBlog,
            fromInspirationId: ideaMass.id,
            hasMove: false,
            url: '/zhikuan/ins/inspiration/update-quick-collect-inspiration'
          })
        }
      })
      collectComplete()
      onCollectNotification()
      afterJoin?.()
    } catch (err) {
      if (err.errorCode === 'MEINIAN_MEAL_AUTH_ERROR_0019') {
        message.error('由于团队版本降级，您需要先前往美念选择需要保留的灵感集。')
        return
      }
      if (err?.errorCode === 'INS0029') { // 单独处理该错误消息
        message.error(err.errorDesc)
        return
      }
      // 判断平台，抖音采集出现错误转为上传采集
      // 采集出现错误时转为上传采集
      if (isCollectReport || platformId === PLATFORM_VALUE.DY) {
        const { mainUrl, picUrl, description = '' } = currentBlog || {}
        const inspirationId = ideaMass.id
        try {
          const itemList = [{
            mainUrl: mainUrl || picUrl,
            desc: description || '',
            tagNameList: [],
            title: ''
          }]
          const res = await request.post('/zhikuan/user-img/upload-img', { inspirationIdList: [inspirationId], itemList })
          if (res?.effectTargetNum && auth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21'])) {
            setTaskConfirmVisible(true)
            taskConfirmTemp.current = res
          }
          messageSuccess({
            collectIdList: res.collectIdList,
            loginUserInfo: res.loginUserInfo,
            name: res.name,
            data: res,
          })
          collectComplete()
          onCollectNotification()
          afterJoin?.()
        } catch (error) {
          message.error(error.errorDesc || error)
        }
      } else {
        message.error(err.errorDesc || err)
      }
      setTimeout(() => { // 其他项目的message无法关闭 为了主动关闭
        message.destroy()
      }, 8000)
    }
    setLoading(false)
    onCollect?.(currentBlog?.item)
    itemId && util.track('collectgoods', { ...util.getTrackModule(), itemId, itemName: title })
  }

  const onTaskConfirmOk = () => {
    setTaskConfirmVisible(false)
  }

  const collectComplete = () => {
    util.track('mn-add-style', {
      module1: getProjectSource(),
      module2: '快速采集'
    })
  }

  return <>
    <a
      className={classNames('fast-collect-trigger', className)}
      onClick={(e) => {
        e.stopPropagation()
        _onCollect()
      }}
    >
      {children || <Icon type="m-kuaisucaiji" />}
    </a>
    {
      taskConfirmVisible && (taskConfirmTemp.current?.collectIdList?.[0] || taskConfirmTemp.current?.collectId) && <AssociateTaskModal
        collectId={taskConfirmTemp.current?.collectIdList?.[0] || taskConfirmTemp.current?.collectId}
        visible={taskConfirmVisible}
        onClose={() => setTaskConfirmVisible(false)}
        onOk={onTaskConfirmOk}
      />
    }
  </>
}

export const PROJECT_ENUM = {
  zhiyi: 'zhiyi'
}

const FastCollect = (props) => {
  const { className, children, project, ...otherProps } = props
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {
      userInfo?.isWhalePick && project === PROJECT_ENUM.zhiyi ? <Collect className={classNames('fast-collect-trigger', className)} {...otherProps}>
        {children || <Icon type="m-kuaisucaiji" />}
      </Collect> : <TempFastCollect className={className} {...otherProps}>
        {children || <Icon type="m-kuaisucaiji" />}
      </TempFastCollect>
  }
  </>
}

export default FastCollect
